<template>
    <div>
        <Form inline>
            <FormItem
                :label="$t('erp.b2c.order_no', { defaultValue: '订单号' })"
                :label-width="70"
            >
                <Input v-model="formData.CN_orderNo"></Input>
            </FormItem>

            <FormItem :label-width="1">
                <Button
                    type="primary"
                    @click="getVsGroupRule"
                    icon="ios-search"
                    >{{
                        $t("tms.ship.search_for", { defaultValue: "搜索" })
                    }}</Button
                >
                <Button @click="reset" icon="md-refresh">{{
                    $t("tms.ship.reset", { defaultValue: "重置" })
                }}</Button>
            </FormItem>
        </Form>
        <Table
            :columns="columns"
            :data="data"
            stripe
            border
            :loading="loading"
        ></Table>
        <compSpage
            class="text-right margin-top-10"
            v-bind="{ total, pageSize: formData.rows, current: formData.page }"
            @on-update="updateList"
        ></compSpage>
    </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import compSpage from "@/components/boss/spage";
import { HttpB2cList } from "@/service/boss/b2corder";
export default {
    props: ["virtalertsearch"],
    components: {
        compSpage,
    },
    data() {
        return {
            formData: {
                page: 1,
                rows: 10,
                CN_orderNo: "",
            },
            title: "",
            rowId: "",
            data: [],
            total: 0,
            loading: false,
        };
    },
    created() {
        this.updateList();
    },
    watch: {
        virtalertsearch: function () {
            // console.log(this.virtalertsearch)
            if (this.virtalertsearch == true) {
                this.updateList();
            }
        },
    },
    computed: {
        // ...mapState('boss',['products']),
        // ...mapGetters('boss',['warehouses']),
        ...mapGetters("diction", ["getNewProductList"]),
        columns() {
            return [
                {
                    width: 65,
                    render: (h, { row, index }) => {
                        return h("Radio", {
                            props: {
                                value: this.rowId === index,
                            },
                            on: {
                                input: (event) => {
                                    this.rowId = index;
                                },
                            },
                        });
                    },
                },
                {
                    title: this.$t("erp.b2c.order_no", {
                        defaultValue: "订单号",
                    }),
                    render: (h, { row }) => {
                        return (
                            <div>
                                <div>{row.id}</div>
                                <div>{row.orderNo}</div>
                            </div>
                        );
                    },
                },
                {
                    title: this.$t("erp.b2c.channel", {
                        defaultValue: "渠道",
                    }),
                    render: (h, { row }) => {
                        return (
                            <div>
                                <div>
                                    {row.channelFlag}[{row.channel}]
                                </div>
                            </div>
                        );
                    },
                },
                {
                    title: this.$t("boss.purchase.project", {
                        defaultValue: "项目",
                    }),
                    width: 180,
                    render: (h, { row }) => {
                        const id = row.lineId;
                        const product =
                            this.getNewProductList.filter((item) => {
                                return id == item.value;
                            })[0] || {};
                        return (
                            <div>
                                <div>
                                    <span>{product.label || "--"}</span>
                                </div>
                            </div>
                        );
                    },
                },
                {
                    title: this.$t("erp.b2c.creation_date", {
                        defaultValue: "创建日期",
                    }),
                    width: 200,
                    render: (h, { row }) => {
                        return (
                            <div>
                                <div>{row.channelCreated}</div>
                            </div>
                        );
                    },
                },
                {
                    title: this.$t("boss.purchase.state", {
                        defaultValue: "状态",
                    }),
                    width: 100,
                    render: (h, { row }) => {
                        switch (row.orderStatus) {
                            case "pending":
                                return (
                                    <div class="b2cspan-error span-padding">
                                        {this.$t(
                                            "erp.b2c.orderstatus_pending",
                                            {
                                                defaultValue: "未支付",
                                            }
                                        )}
                                    </div>
                                );
                                break;
                            case "unshipped":
                                return (
                                    <div class="b2cspan-middle-content span-padding">
                                        {this.$t(
                                            "erp.b2c.orderstatus_unshipped",
                                            {
                                                defaultValue: "未发货",
                                            }
                                        )}
                                    </div>
                                );
                                break;
                            case "approved":
                                return (
                                    <div class="b2cspan-success span-padding">
                                        {this.$t(
                                            "erp.b2c.orderstatus_approved",
                                            {
                                                defaultValue: "已审核",
                                            }
                                        )}
                                    </div>
                                );
                                break;
                            case "assigned":
                                return (
                                    <div class="b2cspan-primary span-padding">
                                        {this.$t(
                                            "erp.b2c.orderstatus_assigned",
                                            {
                                                defaultValue: "已分配",
                                            }
                                        )}
                                    </div>
                                );
                                break;
                            case "picked":
                                return (
                                    <div class="b2cspan-info span-padding">
                                        {this.$t("erp.b2c.orderstatus_picked", {
                                            defaultValue: "已配货",
                                        })}
                                    </div>
                                );
                                break;
                            case "shipped":
                                return (
                                    <div class="b2cspan-light-content span-padding">
                                        {this.$t(
                                            "erp.b2c.orderstatus_shipped",
                                            {
                                                defaultValue: "已发货",
                                            }
                                        )}
                                    </div>
                                );
                                break;
                            case "canceled":
                                return (
                                    <div class="b2cspan-warning span-padding">
                                        {this.$t(
                                            "erp.b2c.orderstatus_canceled",
                                            {
                                                defaultValue: "已取消",
                                            }
                                        )}
                                    </div>
                                );
                                break;
                            case "refunded":
                                return (
                                    <div class="b2cspan-dark-primary span-padding">
                                        {this.$t(
                                            "erp.b2c.orderstatus_refunded",
                                            {
                                                defaultValue: "已退款",
                                            }
                                        )}
                                    </div>
                                );
                                break;
                        }
                    },
                },
            ];
        },
    },
    methods: {
        getRowData() {
            return this.data[this.rowId] || {};
        },
        reset() {
            this.formData = {
                page: 1,
                rows: 10,
                CN_orderNo: "",
            };
            this.getVsGroupRule("reset");
            this.$emit("on-reset");
        },
        async getVsGroupRule(type) {
            this.loading = true;
            const response = await HttpB2cList({
                page: 1,
                rows: 10,
                search: {
                    CN_orderNo: this.formData.CN_orderNo,
                    EQ_parentId: 0,
                    EQ_fulfillmentChannel: "MFN",
                },
            });
            if (response) {
                this.loading = false;
                this.total = response.data.totalElements || 0;
                this.handleList(response.data.content);
            }
        },
        async updateList(data) {
            this.loading = true;
            this.formData = Object.assign({}, this.formData, data);
            const response = await HttpB2cList({
                page: this.formData.page,
                rows: this.formData.rows,
                search: {
                    CN_orderNo: this.formData.CN_orderNo,
                },
            }).catch((res) => {
                this.loading = false;
                this.$Message.error(res.message);
            });
            if (response) {
                this.loading = false;
                this.handleList(response.data.content);
                this.total = response.data.totalElements || 0;
            }
        },
        handleList(content) {
            let aaa = content.map((item) => {
                return {
                    id: item.id,
                    orderNo: item.orderNo,
                    channelFlag: item.channelFlag,
                    channel: item.channel,
                    lineId: item.lineId,
                    channelCreated: item.channelCreated,
                    orderStatus: item.orderStatus,
                };
            });
            this.data = aaa;
        },
    },
};
</script>
